import { Field as ChakraField } from '@chakra-ui/react'
import type {
  FieldErrorTextProps,
  FieldHelperTextProps,
  FieldLabelProps,
  FieldRootProps,
} from '@chakra-ui/react'

const FieldRoot = (props: FieldRootProps) => {
  return <ChakraField.Root {...props} />
}

const FieldLabel = (props: FieldLabelProps) => {
  return (
    <ChakraField.Label {...props}>
      {props.children}
      <ChakraField.RequiredIndicator />
    </ChakraField.Label>
  )
}

const FieldHelperText = (props: FieldHelperTextProps) => {
  return <ChakraField.HelperText {...props} />
}

const FieldErrorText = (props: FieldErrorTextProps) => {
  return <ChakraField.ErrorText {...props} />
}

export const Field = {
  Root: FieldRoot,
  Label: FieldLabel,
  HelperText: FieldHelperText,
  ErrorText: FieldErrorText,
}
